<template>
    <b-card-footer
        :footer-bg-variant="footerBgColor"
        :footer-text-variant="footerTextColor"
        :footer-class="footerClass"
    >
        <slot />
    </b-card-footer>
</template>

<script>
// Components.
import {BCardFooter} from 'bootstrap-vue'

export default {
    components: {BCardFooter},
    props: {
        footerBgColor: {type: String},
        footerClass: {type: String},
        footerTextColor: {type: String},
    },
}
</script>